import { AchievementsBlockConfig } from './achievements/codecs';
import { ActivityFeedBlockConfig } from './activity-feed/codecs';
import { BannerBlockConfig } from './banner/codecs';
import { ChallengeCarouselBlockConfig } from './challenge-carousel/codecs';
import { ChallengeListBlockConfig } from './challenge-list/codecs';
import { ChannelPageBlockConfig } from './channel-page/codecs';
import { ChatPageBlockConfig } from './chat-page/codecs';
import { EditProfileBlockConfig } from './edit-profile/codecs';
import { ErrorBlockConfig } from './error/codecs';
import { FooterBlockConfig } from './footer/codecs';
import { HtmlBlockConfig } from './html/codecs';
import { LeaderboardBlockConfig } from './leaderboard/codecs';
import { NavBlockConfig } from './nav/codecs';
import { NotFoundBlockConfig } from './not-found/codecs';
import { PrivacyPolicyBlockConfig } from './privacy-policy/codecs';
import { ProfileBlockConfig } from './profile/codecs';
import { ProfileAchievementsBlockConfig } from './profile-achievements/codecs';
import { ProfileActivityFeedBlockConfig } from './profile-activity-feed/codecs';
import { ProfilePageBlockConfig } from './profile-page/codecs';
import { ReferPageBlockConfig } from './refer-page/codecs';
import { ReferralDashboardBlockConfig } from './referral-dashboard/codecs';
import { RewardDetailsPageBlockConfig } from './reward-details-page/reward-details/codecs';
import { RewardsBlockConfig } from './rewards/codecs';
import { RewardsPageBlockConfig } from './rewards-page/codecs';
import { StreakerBlockConfig } from './streaker/codecs';
import { TermsAndConditionsBlockConfig } from './terms-and-conditions/codecs';
import { TextBlockConfig } from './text/codecs';
import { WishlistBlockConfig } from './wishlist/codecs';
export var LeafBlockConfigs = {
  AchievementsBlockConfig: AchievementsBlockConfig,
  ActivityFeedBlockConfig: ActivityFeedBlockConfig,
  BannerBlockConfig: BannerBlockConfig,
  ChallengeCarouselBlockConfig: ChallengeCarouselBlockConfig,
  ChallengeListBlockConfig: ChallengeListBlockConfig,
  ChannelPageBlockConfig: ChannelPageBlockConfig,
  ChatPageBlockConfig: ChatPageBlockConfig,
  EditProfileBlockConfig: EditProfileBlockConfig,
  ErrorBlockConfig: ErrorBlockConfig,
  FooterBlockConfig: FooterBlockConfig,
  HtmlBlockConfig: HtmlBlockConfig,
  LeaderboardBlockConfig: LeaderboardBlockConfig,
  NavBlockConfig: NavBlockConfig,
  NotFoundBlockConfig: NotFoundBlockConfig,
  PrivacyPolicyBlockConfig: PrivacyPolicyBlockConfig,
  ProfileAchievementsBlockConfig: ProfileAchievementsBlockConfig,
  ProfileActivityFeedBlockConfig: ProfileActivityFeedBlockConfig,
  ProfileBlockConfig: ProfileBlockConfig,
  ProfilePageBlockConfig: ProfilePageBlockConfig,
  ReferPageBlockConfig: ReferPageBlockConfig,
  ReferralDashboardBlockConfig: ReferralDashboardBlockConfig,
  RewardDetailsPageBlockConfig: RewardDetailsPageBlockConfig,
  RewardsBlockConfig: RewardsBlockConfig,
  RewardsPageBlockConfig: RewardsPageBlockConfig,
  StreakerBlockConfig: StreakerBlockConfig,
  TermsAndConditionsBlockConfig: TermsAndConditionsBlockConfig,
  TextBlockConfig: TextBlockConfig,
  WishlistBlockConfig: WishlistBlockConfig
};